import { useId } from "react";

import { cn } from "@/lib/utils";

export function BackIcon({ className, ...props }: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("size-10.5", className)}
      viewBox="0 0 42 42"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        cx="21"
        cy="21"
        fill="none"
        r="20"
        stroke={`url(#${id})`}
        strokeWidth="2"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={id}
          x1="20.942"
          x2="20.942"
          y1="1"
          y2="41"
        >
          <stop stopColor="#eb297b" />
          <stop offset="1" stopColor="#9b3699" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function TopIcon({ className, ...props }: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("size-10.5", className)}
      viewBox="0 0 42 42"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        cx="21"
        cy="21"
        fill="none"
        r="20"
        stroke={`url(#${id})`}
        strokeWidth="2"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={id}
          x1="27.127"
          x2="-2.381"
          y1="-13.754"
          y2="13.993"
        >
          <stop stopColor="#96deda" />
          <stop offset="1" stopColor="#1cd8d2" />
        </linearGradient>
      </defs>
    </svg>
  );
}
